import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mainDiv: {
    display: 'grid',
    gridTemplateColumns: '7fr 4fr 4fr',
    alignItems: 'center',
    padding: '6px 0 6px 12px',
    marginBottom: 4,
    marginTop: 4,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      padding: '6px 0 6px 0',
      gridTemplateColumns: '7fr  4fr',
      gap: 3
    }
  },
  disabled: { opacity: '50%' }
}))
